import { Realm } from '@/model';
import api from '@/rest-api';
import { uniqueIndex } from '@/util/array-util';
import Vue from 'vue';

function realmSorter(a: Realm, b: Realm): number {
  if (a.dfault) {
    return -1;
  } else if (b.dfault) {
    return 1;
  }
  return a.name.localeCompare(b.name);
}

function createStore() {
  const state = Vue.observable({
    realms: [] as readonly Realm[],
  });
  function index() {
    return uniqueIndex(state.realms || [], (l) => l.id);
  }
  function mainRealm() {
    return state.realms.find((r) => r.dfault)?.id;
  }
  const getters = Vue.observable({
    lookup: index(),
    main: mainRealm(),
  });
  const commit = {
    setRealms(rs: Realm[]) {
      rs.sort(realmSorter);
      state.realms = rs;
      getters.lookup = index();
      getters.main = mainRealm();
    },
    realmChange(realm: Realm) {
      const rs = [...state.realms, realm];
      rs.sort(realmSorter);
      state.realms = rs;
      getters.lookup = index();
      getters.main = mainRealm();
    },
  };
  const dispatch = {
    async all(): Promise<readonly Realm[]> {
      if (state.realms.length > 0) {
        return state.realms;
      }
      const rs = await api.realms();
      commit.setRealms(rs);
      return rs;
    },
  };
  return {
    state, getters, dispatch,
  };
}

const realms = createStore();
export default realms;
